/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceCreateTemplate {
    getFixupPrototypeFunction() { return ResourceCreateTemplate.fixupPrototype; }

    static newInstance(model: Partial<ResourceCreateTemplate>): ResourceCreateTemplate {
        let obj = Object.assign(new ResourceCreateTemplate(), model);
        ResourceCreateTemplate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceCreateTemplate>): ResourceCreateTemplate {
        if (!model) return null;
        return ResourceCreateTemplate.newInstance(<ResourceCreateTemplate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceCreateTemplate) {
        if (!obj) return;

        models.ResourceCreateTemplate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceCreateTemplate): boolean {
        Object.setPrototypeOf(obj, ResourceCreateTemplate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the automation template that creates this resource type
     */
    template_name: string;

    /**
     * Identifier of the automation template in the caller's tenant, used to execute it
     */
    template_id: string;

    /**
     * Display label for the create action
     */
    label: string;

}
